import React, { useEffect, useState, useCallback, useRef } from "react";

import { Link } from "react-router-dom";

import { ethers } from "ethers";
import { useAccount, useSigner, useProvider, useNetwork } from "wagmi";

import {
  EDITIONS_MINT_ADDRESS,
  EDITIONS_MINT_ABI,
} from "../../config/configEditionBurnMintExp.js";
import {
    WRAPPER_ABI,
    WRAPPER_ADDRESS,
    SOULSLOCKER_ABI,
    SOULSLOCKER_ADDRESS,
} from "../../config/configMerging.js";
import {
    calculateRedeemableExp,
    spiritsToMint,
    approveSacrifice,
    isSacrificeApprovedCheck,
    sacrificeActive,
    // getSpiritsEditionsCounter,
    ethToMint,
    // getEthEditionsCounter,
    getEditionsCounter,
    experienceToMint,
    areHeroesUsed,
} from "../../helpers/editionBurnMintExpHelpers.js";

import {
    EXPERIENCE_ABI,
    EXPERIENCE_ADDRESS,
} from "../../config/configExperience";

import {
    MULTICALL2_ABI,
    MULTICALL2_ADDRESS,
} from "../../config/configMulticall";

import "./style.css";
import {
    Grid,
    useMediaQuery,
    Input,
    Button,
    Modal,
    TextField,
    CircularProgress,
    Snackbar,
    Stack,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";

import { listAnimeSpiritsHeroesOfOwner_separate } from "../../helpers/mergerHelpers.js";
import { getBatchHeroExpDataAndClaimableExp } from "../../helpers/leaderboardHelpers.js";

import Fade from "@mui/material/Fade";

import editionImage from "../../assets/heretics/KALUTHIEL_1_web_V1.png";
import zenithVideo from "../../assets/toomuchlag_Zenith_50mb.mp4";



const EditionBurnMintExp = () => {
    let { address, isConnected } = useAccount();
    const provider = useProvider();

    const targetTimestamp = 1700502335;
    
    const { data: signer, isError, isLoading } = useSigner();
    const {chain} = useNetwork()

    const matchesExtraLarge = useMediaQuery("(max-width:1600px)");
    const matchesLarge = useMediaQuery("(max-width:1500px)");
    const matchesMedium = useMediaQuery("(max-width:1200px)");
    const matchesSmall = useMediaQuery("(max-width:1024px)");
    const matchesMobile = useMediaQuery("(max-width:600px)");

    const [isChainSupported, setIsChainSupported] = useState(false)

    const [pageOpen, setZenithOpen] = useState(true);

    const [allHeroes, setAllHeroes] = useState([]);
    const [allSpirits, setAllSpirits] = useState([]);

    const [sacrificeOpen, setSacrificeOpen] = useState(false);
    const [selectedHero, setSelectedHero] = useState(null);
    const [selectedSpirits, setSelectedSpirits] = useState([]);
    const [expOfHeroes, setExpOfHeroes] = useState({});
    const [isHeroUsed, setIsHeroUsed] = useState({});

    const [expModalOpen, setExpModalOpen] = useState(false); 

    const [editionsRemaining, setEditionsRemaining] = useState(null);

    const [confirmedSacrifice, setConfirmedSacrifice] = useState(false);
    const [confirmedHero, setConfirmedHero] = useState(false);
    const [isSacrificeActive, setIsSacrificeActive] = useState(false);

    // CONTRACTS
    const [wrapperContract, setWrapperContract] = useState(null);
    const [lockerContract, setLockerContract] = useState(null);
    const [sacrificeContract, setSacrificeContract] = useState(null);
    const [experienceContract, setExperienceContract] = useState(null);
    const [multicallContract, setMulticallContract] = useState(null);

    const [isSacrificeApproved, setIsSacrificeApproved] = useState(false);

    const [isApproveLoading, setIsApproveLoading] = useState(false);

    const [isSacrificeLoading, setIsSacrificeLoading] = useState(false);

    const [openCelebrationModal, setOpenCelebrationModal] = useState(false);

    const [notification, setNotification] = useState({});

    const [videoSrc, setVideoSrc] = useState(null);



    // Refresh sacrificeActive and sacrificeCounter every 30 seconds
    function useInterval(callback, delay) {
      const savedCallback = useRef();
    
      // Remember the latest callback.
      useEffect(() => {
        savedCallback.current = callback;
      }, [callback]);
    
      // Set up the interval.
      useEffect(() => {
        function tick() {
          savedCallback.current();
        }
        if (delay !== null) {
          let id = setInterval(tick, delay);
          return () => clearInterval(id);
        }
      }, [delay]);
    }
    
    useInterval(async () => {
      if (signer && address && provider && isChainSupported) {
        const sacrificeActive_ = await sacrificeActive(sacrificeContract);
        setIsSacrificeActive(sacrificeActive_);
      }
      const spiritsEditionsRemaining = await getEditionsCounter(
        sacrificeContract,
        EDITIONS_MINT_ADDRESS
    );

      setEditionsRemaining(spiritsEditionsRemaining);

      if(spiritsEditionsRemaining == 0) {
        setIsSacrificeActive(false);
      }
      // console.log('update sacrificeActive and editionsRemaining')
   
    }, 30000); // 60000 milliseconds = 60 seconds

    // USE EFFECTS
    useEffect(() => {
        //STYLE
        document.body.style.background = ` linear-gradient(rgba(0,0,0,0.9),rgba(0,0,0,0.9)), url(${editionImage})`;
        document.body.style.backgroundAttachment = "fixed";
        document.body.style.backgroundRepeat = "no-repeat";
        document.body.style.backgroundSize = "cover";
        document.body.style.backgroundColor = "#000000";
        
        return () => {
            document.body.style.background = "#111111";
        };
    }, []);

    useEffect(() => {
        if (signer && address && provider && isChainSupported) {
            const sacrificeContract = new ethers.Contract(
                EDITIONS_MINT_ADDRESS,
                EDITIONS_MINT_ABI,
                signer
            );
            setSacrificeContract(sacrificeContract);

            const wrapperContract = new ethers.Contract(
                WRAPPER_ADDRESS,
                WRAPPER_ABI,
                signer
            );
            setWrapperContract(wrapperContract);

            const lockerContract = new ethers.Contract(
                SOULSLOCKER_ADDRESS,
                SOULSLOCKER_ABI,
                signer
            );
            setWrapperContract(wrapperContract);

            const experienceContract = new ethers.Contract(
                EXPERIENCE_ADDRESS,
                EXPERIENCE_ABI,
                provider
            );
            setExperienceContract(experienceContract);
            const multicallContract = new ethers.Contract(
                MULTICALL2_ADDRESS,
                MULTICALL2_ABI,
                provider
            );
            setMulticallContract(multicallContract);

            const setAllHeroesAndSpiritsFunction = async () => {
                let allTokens = await listAnimeSpiritsHeroesOfOwner_separate(
                    address,
                    wrapperContract,
                    lockerContract
                );

                let allHeroes = allTokens.heroIDs;

                const sortedallHeroes = allHeroes.sort((a, b) => {
                    return a.id - b.id;
                });

                setAllHeroes(sortedallHeroes);
                
                let heroSoulNumbers = sortedallHeroes.map(
                    (hero) => hero.soulNumber
                );

                console.log(heroSoulNumbers);

                // get exp of heroes
                getBatchHeroExpDataAndClaimableExp(
                    multicallContract,
                    experienceContract,
                    heroSoulNumbers
                )
                    .then((data) => {
                        // map hero id to exp, expClaimable, expAvailable
                        let expOfHeroes = {};
                        data.forEach((hero) => {
                            expOfHeroes[hero.heroId] = {
                                exp: parseInt(hero.exp / 1000000),
                                expClaimable: parseInt(
                                    hero.expClaimable / 1000000
                                ),
                                expAvailable: parseInt(
                                    hero.expAvailable / 1000000
                                ),
                            };
                        });
                        console.log("expOfHeroes", expOfHeroes);
                        setExpOfHeroes(expOfHeroes);
                    })
                    .catch((err) => {
                        console.log("expOfHeroes error", err);
                        setExpOfHeroes({});
                    });
                
                areHeroesUsed(
                    sacrificeContract,
                    multicallContract,
                    heroSoulNumbers
                )
                    .then((data) => {
                        // map hero id to isUsed
                        let isHeroUsed = {};
                        data.forEach((hero) => {
                            isHeroUsed[hero.heroId] = hero.isUsed;
                        });
                        console.log("isHeroUsed", isHeroUsed);
                        setIsHeroUsed(isHeroUsed);
                    })
                    .catch((err) => { 
                        console.log("isHeroUsed error", err);
                        setIsHeroUsed({});
                    });
                  
                let allSouls = allTokens.tokenIDs;

                const sortedAllSouls = allSouls.sort((a, b) => {
                    return a.id - b.id;
                });

                // remove all ids < 1574 - Spirits Only
                const filteredAllSpirits = sortedAllSouls.filter((soul) => {
                    return soul.soulNumber >= 1574;
                });

                // sort filtered spirits by .traits[0][1] ascending
                filteredAllSpirits.sort((a, b) => {
                    return a.traits[0][1] - b.traits[0][1];
                });

                let currentTimestamp = Math.floor(Date.now() / 1000);

                // add experience to each spirit
                filteredAllSpirits.forEach((spirit) => {
                    spirit.exp = calculateRedeemableExp(
                        [spirit.soulNumber],
                        currentTimestamp
                    );
                });

                setAllSpirits(filteredAllSpirits);

                const sacrificeActive_ = await sacrificeActive(sacrificeContract)
                setIsSacrificeActive(sacrificeActive_);

                const isSacrificeApprovedBool = await isSacrificeApprovedCheck(
                    address,
                    wrapperContract,
                    EDITIONS_MINT_ADDRESS
                );

                setIsSacrificeApproved(isSacrificeApprovedBool);

                const spiritsEditionsRemaining = await getEditionsCounter(
                    sacrificeContract,
                    EDITIONS_MINT_ADDRESS
                );

                setEditionsRemaining(spiritsEditionsRemaining);

                if(spiritsEditionsRemaining == 0) {
                  setIsSacrificeActive(false);
                }

            };

            setAllHeroesAndSpiritsFunction();

        }

        
    }, [signer, address, provider, isChainSupported]);

    useEffect(() => {
      if (typeof chain !== "undefined" && typeof chain.unsupported !== "undefined") {
        setIsChainSupported(!chain.unsupported)
      }
      // console.log("chain changed", chain)
    }, [chain])

    useEffect(() => {
        // let currentTimestamp = Math.floor(Date.now() / 1000);
    }, [selectedSpirits]);

    const openPage = () => {
        setZenithOpen(true);
    };
    const handleImageClick = () => {
      setVideoSrc();
    };
    // SACRIFICE MODAL FUNCTIONS
    const handleSetDefaultImage = (e, id) => {
        e.target.src = `https://leanime.art/heroes/m/${id}.jpg`;
    };

    const handleReload = () => {
      window.location.reload();
  };
    const handlesetSelectedHero = (heroID) => {
        setSelectedHero({
            id: heroID,
        });
        handleConfirmHero();
    };

    const handleSelectSpirits = (soulNumber) => {
        const found = selectedSpirits.find((obj) => obj === soulNumber);
        if (!found) {
            // all selected + maintoken [0]
            setSelectedSpirits([...selectedSpirits, soulNumber]);
        } else {
            const filteredSelectedSpirits = selectedSpirits.filter(
                (obj) => obj !== soulNumber
            );

            setSelectedSpirits(filteredSelectedSpirits);
        }
    };

    const handleConfirmSacrifice = () => {
        setConfirmedSacrifice(true);
    };

    const handleConfirmHero = () => {
        setConfirmedHero(true);
    };

    const handleApproveSacrifice = () => {
        setIsApproveLoading(true);
        approveSacrifice(wrapperContract, EDITIONS_MINT_ADDRESS)
            .then(() => {
                setIsSacrificeApproved(true);
                setIsApproveLoading(false);
                setNotification({
                    state: true,
                    message: "Sacrifice contract succesfully approved",
                    type: "success",
                });
            })
            .catch((err) => {
                setIsApproveLoading(false);
                setIsSacrificeApproved(false);
                setNotification({
                    state: true,
                    message: err.data ? err.data.message : err.message,
                    type: "error",
                });
            });
    };

    const handleSacrificeTransaction = () => {
        setIsSacrificeLoading(true);

        // add 100000 to all selected spirits
        let selectedSpiritsToExp = selectedSpirits.map((spirit) => {
            return spirit + 100000;
        });
        spiritsToMint(sacrificeContract, selectedSpiritsToExp)
            .then(() => {
                // setSacrificeOpen(false);
                setOpenCelebrationModal(true);
                setIsSacrificeLoading(false);
                setNotification({
                    state: true,
                    message: "Sacrifice & Mint succesfully completed",
                    type: "success",
                });
            })
            .catch((err) => {
                setIsSacrificeLoading(false);
                setNotification({
                    state: true,
                    message: err.data ? err.data.message : err.message,
                    type: "error",
                });
            });
    };

    const handleCloseSacrifice = () => {
        setSacrificeOpen(false);
        setSelectedHero(null);
        setConfirmedSacrifice(false);
        setSelectedSpirits([]);
        setOpenCelebrationModal(false);
        handleReload();
    };

    const handleMintEdition = () => {
        setIsSacrificeLoading(true);

        // add 100000 to all selected spirits
        // let selectedSpiritsToExp = selectedSpirits.map((spirit) => {
        //     return spirit + 100000;
        // });
        ethToMint(sacrificeContract)
            .then(() => {
                // setSacrificeOpen(false);
                setOpenCelebrationModal(true);
                setIsSacrificeLoading(false);
                setNotification({
                    state: true,
                    message: "Mint succesfully completed",
                    type: "success",
                });
            })
            .catch((err) => {
                // setOpenCelebrationModal(true);
                setIsSacrificeLoading(false);
                setNotification({
                    state: true,
                    message: err.data ? err.data.message : err.message,
                    type: "error",
                });
            });
    };

    const handleCloseExpModal = () => {
        setExpModalOpen(false);
        setConfirmedSacrifice(false);
        setSelectedSpirits([]);
        setOpenCelebrationModal(false);
        setSelectedHero(null);
        handleReload();
    };

    const handleMintWithExp = () => {
        setIsSacrificeLoading(true);

        console.log(selectedHero)

        experienceToMint(sacrificeContract, selectedHero.id)
            .then(() => {
                // setSacrificeOpen(false);
                setOpenCelebrationModal(true);
                setIsSacrificeLoading(false);
                setNotification({
                    state: true,
                    message: "Mint succesfully completed",
                    type: "success",
                });
            })
            .catch((err) => {
                // setOpenCelebrationModal(true);
                setIsSacrificeLoading(false);
                setNotification({
                    state: true,
                    message: err.data ? err.data.message : err.message,
                    type: "error",
                });
            });
    };


    const handleDismissSnackBar = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setNotification({ status: false });
    };
    return (
        <Grid
            container
            direction="column"
            justifyContent="start"
            alignItems="center"
            style={{
                paddingTop: "100px",
                width: "100%",
                height: "100%",
            }}
        >
            <Stack spacing={2} sx={{ width: "100%" }}>
                <Snackbar
                    autoHideDuration={2000}
                    open={notification.state && notification.type === "error"}
                    onClose={handleDismissSnackBar}
                    key={"error"}
                >
                    <MuiAlert
                        onClose={handleDismissSnackBar}
                        variant="filled"
                        severity="error"
                    >
                        {notification.message}
                    </MuiAlert>
                </Snackbar>
                <Snackbar
                    autoHideDuration={2000}
                    open={notification.state && notification.type === "success"}
                    onClose={handleDismissSnackBar}
                    key={"success"}
                >
                    <MuiAlert
                        onClose={handleDismissSnackBar}
                        variant="filled"
                        severity="success"
                    >
                        {notification.message}
                    </MuiAlert>
                </Snackbar>
            </Stack>
            <Modal
                disableScrollLock={true}
                style={{ border: "none" }}
                open={sacrificeOpen}
                onClose={handleCloseSacrifice}
            >
                <Fade in={sacrificeOpen}>
                    <div
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: matchesMobile ? "100%" : "70%",
                            height: "auto",
                            padding: "40px 0",
                            maxHeight: "80%",
                            background: "#111111",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "start",
                            alignItems: "center",
                            borderRadius: "10px",
                            outline: "none",
                            // paddingTop: "25px",
                            color: "white",
                            overflowY: "auto",
                            overflowX: "hidden",
                        }}
                    >
                        {!confirmedSacrifice && !openCelebrationModal && (
                            <div
                                style={{
                                    width: "90%",
                                    height: "100%",
                                    textAlign: "center",
                                    display: "flex",
                                    // padding: "20px",
                                    flexDirection: "column",
                                    justifyContent: "start",
                                    // alignItems: "center",
                                }}
                            >
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{
                                        width: "100%",
                                        marginBottom: "0px",
                                    }}
                                >
                                    <Grid
                                        item
                                        xs={12}
                                        style={{
                                            fontFamily: "PPNeueMachina",
                                            fontSize: matchesMobile
                                                ? "14px"
                                                : matchesSmall
                                                ? "16px"
                                                : "18px",
                                            textAlign: "center",
                                            color: "#ffb631",
                                        }}
                                    >
                                        STEP 1: SELECT THE SPIRITS YOU WANT TO
                                        SACRIFICE
                                    </Grid>
                                </Grid>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="start"
                                    alignItems="start"
                                    spacing={matchesMobile ? 1 : 2}
                                    style={{
                                        marginTop: "20px",
                                        marginBottom: "20px",
                                        width: "100%",
                                        height: matchesMobile ? "70%" : "80%",
                                        overflowY: "auto",
                                        overflowX: "hidden",
                                    }}
                                >
                                    {allSpirits &&
                                        allSpirits.map((t, i) => {
                                            const isSelected =
                                                selectedSpirits.find(
                                                    (obj) =>
                                                        obj === t.soulNumber
                                                );
                                            return (
                                                <Grid
                                                    item
                                                    xs={
                                                        matchesMobile
                                                            ? 6
                                                            : matchesSmall
                                                            ? 3
                                                            : 1.5
                                                    }
                                                    key={t.soulNumber}
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        justifyContent:
                                                            "center",
                                                        // fontSize: matchesMobile? "12px" : "8px",
                                                    }}
                                                >
                                                    <img
                                                        onClick={() =>
                                                            handleSelectSpirits(
                                                                t.soulNumber
                                                            )
                                                        }
                                                        style={{
                                                            width: "100%",
                                                            cursor: "pointer",
                                                            border: "2px solid transparent",
                                                            borderColor:
                                                                isSelected
                                                                    ? "#ffb631"
                                                                    : "transparent",
                                                            boxSizing:
                                                                "border-box",
                                                        }}
                                                        src={`https://leanime.art/heroes/m/${t.soulNumber}.jpg`}
                                                    />{" "}
                                                    <span
                                                        style={{
                                                            marginTop: "2px",
                                                        }}
                                                    >
                                                        #{t.soulNumber}
                                                    </span>
                                                    {/* <span
                                                        style={{
                                                            marginTop: "3px",
                                                            fontSize: "12px",
                                                        }}
                                                    >
                                                        {t.exp} EXP
                                                    </span> */}
                                                </Grid>
                                            );
                                        })}
                                </Grid>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{
                                        width: "100%",
                                        marginBottom: "15px",
                                    }}
                                >
                                    <Grid
                                        item
                                        xs={matchesMobile ? 12 : 6}
                                        style={{
                                            fontFamily: "PPNeueMachina",
                                            fontSize: matchesMobile
                                                ? "14px"
                                                : "16px",
                                            textAlign: "center",
                                            color: "#ffb631",
                                        }}
                                    >
                                        SELECT 3 SPIRITS TO SACRIFICE
                                    </Grid>

                                    <Grid item xs={matchesMobile ? 12 : 6}>
                                        <Button
                                            onClick={handleConfirmSacrifice}
                                            disabled={
                                                selectedSpirits.length !== 3
                                            }
                                            style={{
                                                background:
                                                    selectedSpirits.length !== 3
                                                        ? "rgba(255, 182, 49,0.5)"
                                                        : "#ffb631",
                                                color: "black",
                                                width: "250px",
                                                padding: "10px 0",
                                                margin: "10px 0",
                                                borderRadius: 0,
                                                fontSize: "16px",
                                                fontFamily: "EurostilDemi",
                                            }}
                                        >
                                            CONFIRM
                                        </Button>
                                    </Grid>
                                </Grid>
                            </div>
                        )}

                        {confirmedSacrifice && !openCelebrationModal && (
                            <div
                                style={{
                                    width: "90%",
                                    height: "100%",
                                    textAlign: "center",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "start",
                                }}
                            >
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{
                                        width: "100%",
                                        marginBottom: "0px",
                                    }}
                                >
                                    {/* <Grid item xs={3}></Grid> */}
                                    <Grid
                                        item
                                        xs={12}
                                        style={{
                                            fontFamily: "PPNeueMachina",
                                            fontSize: matchesMobile
                                                ? "14px"
                                                : matchesSmall
                                                ? "16px"
                                                : "18px",
                                            textAlign: "center",
                                            color: "#ffb631",
                                        }}
                                    >
                                        STEP 2: REVIEW AND CONFIRM
                                    </Grid>
                                </Grid>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="start"
                                    alignItems="start"
                                    spacing={matchesMobile ? 1 : 2}
                                    style={{
                                        marginTop: "20px",
                                        marginBottom: "20px",
                                        width: "100%",
                                        maxHeight: matchesMobile
                                            ? "60%"
                                            : "70%",
                                        overflowY: "auto",
                                        overflowX: "hidden",
                                    }}
                                >
                                    {selectedSpirits &&
                                        selectedSpirits.map((t, i) => {
                                            return (
                                                <Grid
                                                    item
                                                    xs={
                                                        matchesMobile
                                                            ? 6
                                                            : matchesSmall
                                                            ? 3
                                                            : 1.5
                                                    }
                                                    key={t}
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        justifyContent:
                                                            "center",
                                                    }}
                                                >
                                                    <img
                                                        style={{
                                                            width: "100%",
                                                            boxSizing:
                                                                "border-box",
                                                        }}
                                                        src={`https://leanime.art/heroes/m/${t}.jpg`}
                                                    />{" "}
                                                    <span
                                                        style={{
                                                            marginTop: "5px",
                                                        }}
                                                    >
                                                        #{t}
                                                    </span>
                                                </Grid>
                                            );
                                        })}
                                </Grid>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{
                                        width: "100%",
                                        marginBottom: "15px",
                                    }}
                                >
                                    <Grid
                                        item
                                        xs={12}
                                        style={{
                                            fontFamily: "PPNeueMachina",
                                            fontSize: matchesMobile
                                                ? "14px"
                                                : matchesSmall
                                                ? "16px"
                                                : "20px",
                                            textAlign: "center",
                                            // cursor: "pointer",
                                            color: "#ffb631",
                                        }}
                                    ></Grid>
                                </Grid>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{
                                        width: "100%",
                                        marginBottom: "10px",
                                    }}
                                >
                                    {editionsRemaining > 0 && (
                                        <Grid
                                            item
                                            xs={12}
                                            style={{
                                                fontFamily: "PPNeueMachina",
                                                fontSize: matchesMobile
                                                    ? "12px"
                                                    : "14px",
                                                textAlign: "center",
                                                // cursor: "pointer",
                                                color: "white",
                                            }}
                                        >
                                            FINALIZE SACRIFICE AND RECEIVE AN
                                            EDITION
                                        </Grid>
                                    )}
                                    {editionsRemaining == 0 && (
                                        <Grid
                                            item
                                            xs={12}
                                            style={{
                                                fontFamily: "PPNeueMachina",
                                                fontSize: matchesMobile
                                                    ? "16px"
                                                    : "18px",
                                                textAlign: "center",
                                                // cursor: "pointer",
                                                color: "white",
                                            }}
                                        >
                                            SOLD OUT - NO MORE EDITIONS
                                        </Grid>
                                    )}
                                </Grid>
                                {!isSacrificeApproved && isSacrificeActive && (
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="center"
                                        alignItems="center"
                                        style={{
                                            width: "100%",
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Grid item>
                                            <Button
                                                onClick={handleApproveSacrifice}
                                                style={{
                                                    background: "#ffb631",
                                                    color: "black",
                                                    width: "250px",
                                                    padding: "10px 0",
                                                    marginTop: "10px",
                                                    // margin: "10px 0",
                                                    borderRadius: 0,
                                                    fontSize: "16px",
                                                    fontFamily: "EurostilDemi",
                                                }}
                                                disabled={isSacrificeApproved}
                                            >
                                                {isApproveLoading ? (
                                                    <CircularProgress
                                                        size={28}
                                                    />
                                                ) : (
                                                    "1: APPROVE CONTRACT"
                                                )}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                )}
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                    style={{
                                        width: "100%",
                                        marginBottom: "5px",
                                    }}
                                >
                                    {isSacrificeActive && (
                                        <Grid item>
                                            <Button
                                                onClick={
                                                    handleSacrificeTransaction
                                                }
                                                style={{
                                                    background:
                                                        isSacrificeApproved
                                                            ? "#ffb631"
                                                            : "rgba(255, 182, 49,0.5)",
                                                    color: "black",
                                                    width: "250px",
                                                    padding: "10px 0",
                                                    marginTop: "10px",
                                                    // margin: "10px 0",
                                                    borderRadius: 0,
                                                    fontSize: "16px",
                                                    fontFamily: "EurostilDemi",
                                                }}
                                                disabled={!isSacrificeApproved}
                                            >
                                                {isSacrificeLoading ? (
                                                    <CircularProgress
                                                        size={28}
                                                    />
                                                ) : isSacrificeApproved ? (
                                                    "1: SACRIFICE SPIRITS"
                                                ) : (
                                                    "2: SACRIFICE SPIRITS "
                                                )}
                                            </Button>
                                        </Grid>
                                    )}
                                    <Grid
                                        item
                                        xs={12}
                                        style={{
                                            fontFamily: "PPNeueMachina",
                                            fontSize: "14px",
                                            textAlign: "center",
                                            // cursor: "pointer",
                                            color: "#ff4136",
                                            paddingTop: "20px",
                                            paddingBottom: "0px",
                                        }}
                                    >
                                        WARNING: NFTS SACRIFICED ARE LOST
                                        FOREVER!
                                    </Grid>
                                </Grid>
                            </div>
                        )}

                        {openCelebrationModal && (
                            <div
                                style={{
                                    width: "90%",
                                    height: "100%",
                                    textAlign: "center",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{
                                        width: "100%",
                                        marginBottom: "0px",
                                    }}
                                >
                                    {/* <Grid item xs={3}></Grid> */}
                                    <Grid
                                        item
                                        xs={12}
                                        style={{
                                            fontFamily: "PPNeueMachina",
                                            fontSize: "22px",
                                            textAlign: "center",
                                            color: "#ffffff",
                                            marginBottom: "20px",
                                        }}
                                    >
                                        CONGRATULATIONS, THE MINT WAS SUCCESSFUL{" "}
                                        <br />
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        style={{
                                            fontFamily: "PPNeueMachina",
                                            fontSize: "22px",
                                            textAlign: "center",
                                            color: "#ffffff",
                                            marginBottom: "20px",
                                        }}
                                    >
                                        {/* {editionsToMint > 0 ? `+ ${editionsToMint} EDITION` : ""}{editionsToMint > 1 ? "S" : ""} */}
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        style={{
                                            fontFamily: "EurostilNormal",
                                            fontSize: "15px",
                                            textAlign: "center",
                                            // italic
                                            fontStyle: "italic",
                                            color: "#ffffff",
                                            marginBottom: "20px",
                                        }}
                                    >
                                        {/* Talanji feasts on your Spirits, the echo of the ancestors resonates, <br/> soon illuminating the one who will inherit the ancient power. */}
                                    </Grid>
                                </Grid>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{
                                        width: "100%",
                                        // marginBottom: "10px",
                                    }}
                                ></Grid>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                    style={{
                                        width: "100%",
                                        marginBottom: "5px",
                                    }}
                                >
                                    <Grid item>
                                        <Button
                                            onClick={handleCloseSacrifice}
                                            style={{
                                                background: "#ffb631",
                                                color: "black",
                                                width: "280px",
                                                padding: "10px 0",
                                                marginTop: "15px",
                                                // margin: "10px 0",
                                                borderRadius: 0,
                                                fontSize: "20px",
                                                fontFamily: "EurostilDemi",
                                            }}
                                        >
                                            {"CLOSE"}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </div>
                        )}
                    </div>
                </Fade>
            </Modal>
            <Modal
                disableScrollLock={true}
                style={{ border: "none" }}
                open={expModalOpen}
                onClose={handleCloseExpModal}
            >
                <Fade in={expModalOpen}>
                    <div
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: matchesMobile ? "100%" : "70%",
                            height: "auto",
                            padding: "40px 0",
                            maxHeight: "80%",
                            background: "#111111",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "start",
                            alignItems: "center",
                            borderRadius: "10px",
                            outline: "none",
                            // paddingTop: "25px",
                            color: "white",
                            overflowY: "auto",
                            overflowX: "hidden",
                        }}
                    >
                        {!confirmedHero &&
                            !openCelebrationModal &&
                            allHeroes.length > 0 && (
                                <>
                                    <div
                                        style={{
                                            width: "90%",
                                            height: "100%",
                                            textAlign: "center",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "start",
                                        }}
                                    >
                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="space-between"
                                            alignItems="center"
                                            style={{
                                                width: "100%",
                                                marginBottom: "0px",
                                            }}
                                        >
                                            <Grid
                                                item
                                                xs={12}
                                                style={{
                                                    fontFamily: "PPNeueMachina",
                                                    fontSize: matchesMobile
                                                        ? "14px"
                                                        : matchesSmall
                                                        ? "16px"
                                                        : "18px",
                                                    textAlign: "center",
                                                    color: "#ffb631",
                                                }}
                                            >
                                                STEP 1: SELECT THE HERO WITH EXP
                                                TO USE
                                            </Grid>
                                        </Grid>
                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="start"
                                            alignItems="start"
                                            spacing={matchesMobile ? 1 : 2}
                                            style={{
                                                marginTop: "20px",
                                                marginBottom: "20px",
                                                width: "100%",
                                                height: matchesMobile
                                                    ? "70%"
                                                    : "80%",
                                                overflowY: "auto",
                                                overflowX: "hidden",
                                            }}
                                        >
                                            {allHeroes &&
                                                allHeroes.map((t, i) => {
                                                    const isSelected =
                                                        selectedHero &&
                                                        selectedHero.id ===
                                                            t.soulNumber;

                                                    return (
                                                        <Grid
                                                            item
                                                            xs={
                                                                matchesMobile
                                                                    ? 6
                                                                    : 3
                                                            }
                                                            key={t.soulNumber}
                                                            style={{
                                                                display: "flex",
                                                                flexDirection:
                                                                    "column",
                                                                alignItems:
                                                                    "center",
                                                                justifyContent:
                                                                    "center",
                                                            }}
                                                        >
                                                            <img
                                                                onClick={() => {
                                                                    if (
                                                                        expOfHeroes[
                                                                            t
                                                                                .soulNumber
                                                                        ] &&
                                                                        expOfHeroes[
                                                                            t
                                                                                .soulNumber
                                                                        ]
                                                                            .expAvailable >
                                                                            1 *
                                                                                100000 &&
                                                                        !isHeroUsed[
                                                                            t
                                                                                .soulNumber
                                                                        ]
                                                                    ) {
                                                                        handlesetSelectedHero(
                                                                            t.soulNumber
                                                                        );
                                                                    }
                                                                }}
                                                                style={{
                                                                    width: "100%",
                                                                    cursor:
                                                                        expOfHeroes[
                                                                            t
                                                                                .soulNumber
                                                                        ] &&
                                                                        expOfHeroes[
                                                                            t
                                                                                .soulNumber
                                                                        ]
                                                                            .expAvailable >
                                                                            1 *
                                                                                100000 &&
                                                                        !isHeroUsed[
                                                                            t
                                                                                .soulNumber
                                                                        ]
                                                                            ? "pointer"
                                                                            : "default",
                                                                    opacity:
                                                                        expOfHeroes[
                                                                            t
                                                                                .soulNumber
                                                                        ] &&
                                                                        expOfHeroes[
                                                                            t
                                                                                .soulNumber
                                                                        ]
                                                                            .expAvailable >
                                                                            1 *
                                                                                100000 &&
                                                                        !isHeroUsed[
                                                                            t
                                                                                .soulNumber
                                                                        ]
                                                                            ? 1
                                                                            : 0.5,
                                                                }}
                                                                onError={(
                                                                    e
                                                                ) => {
                                                                    handleSetDefaultImage(
                                                                        e,
                                                                        t.soulNumber
                                                                    );
                                                                }}
                                                                src={`https://api.leanime.art/heroes/images/s/${t.soulNumber}.jpg`}
                                                            />{" "}
                                                            <span
                                                                style={{
                                                                    marginTop:
                                                                        "15px",
                                                                    color: "white",
                                                                    fontFamily:
                                                                        "PPNeueMachina",
                                                                    fontSize:
                                                                        "13px",
                                                                }}
                                                            >
                                                                HERO #
                                                                {t.soulNumber}
                                                                {/* if t.soulNumber is in nft entris print a text */}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    // color: "#ffb631",
                                                                    fontFamily:
                                                                        "PPNeueMachina",
                                                                    fontSize:
                                                                        "13px",
                                                                }}
                                                            >
                                                                {" "}
                                                                {expOfHeroes[
                                                                    t.soulNumber
                                                                ]
                                                                    ? expOfHeroes[
                                                                          t
                                                                              .soulNumber
                                                                      ].expAvailable
                                                                          .toString()
                                                                          .replace(
                                                                              /\B(?=(\d{3})+(?!\d))/g,
                                                                              "'"
                                                                          )
                                                                    : 0}{" "}
                                                                EXP
                                                            </span>
                                                            <span
                                                                style={{
                                                                    color: "rgb(255, 65, 54)",
                                                                    fontFamily:
                                                                        "PPNeueMachina",
                                                                    fontSize:
                                                                        "13px",
                                                                }}
                                                            >
                                                                {" "}
                                                                {expOfHeroes[
                                                                    t.soulNumber
                                                                ] &&
                                                                expOfHeroes[
                                                                    t.soulNumber
                                                                ].expAvailable >
                                                                    1 * 100000
                                                                    ? ""
                                                                    : "MIN 100K EXP REQUIRED"}
                                                            </span>
                                                            <span
                                                                style={{
                                                                    color: "rgb(255, 65, 54)",
                                                                    fontFamily:
                                                                        "PPNeueMachina",
                                                                    fontSize:
                                                                        "13px",
                                                                }}
                                                            >
                                                                {" "}
                                                                {expOfHeroes[
                                                                    t.soulNumber
                                                                ] &&
                                                                !isHeroUsed[
                                                                    t.soulNumber
                                                                ]
                                                                    ? ""
                                                                    : "ALREADY MINTED"}
                                                            </span>
                                                        </Grid>
                                                    );
                                                })}
                                        </Grid>
                                    </div>
                                </>
                            )}

                        {!confirmedHero &&
                            !openCelebrationModal &&
                            !allHeroes.length > 0 && (
                                <>
                                    <span
                                        style={{
                                            fontFamily: "PPNeueMachina",
                                            fontSize: matchesMobile
                                                ? "16px"
                                                : "25px",
                                            color: "white",
                                        }}
                                    >
                                        YOU HAVE NO HEROES
                                    </span>
                                    {/* <span
                                              style={{
                                                  fontFamily: "PPNeueMachina",
                                                  fontSize: "20px",
                                              }}
                                          >
                                              <Button
                                                  style={{
                                                      background:
                                                          "#ffb631",

                                                      width: matchesMobile? "90%" : "100%",
                                                      // paddingLeft: "10px",
                                                      marginTop: "20px",
                                                      borderRadius: 0,
                                                      fontSize: matchesMobile? "16px" : "20px",
                                                      fontFamily: "EurostilDemi",
                                                  }}
                                              >
                                                  <Link
                                                      style={{
                                                          textDecoration: "none",
                                                          cursor: "pointer",
                                                          color: "black",
                                                      }}
                                                      to="/builder"
                                                  >
                                                      CREATE NEW HERO
                                                  </Link>
                                              </Button>
                                          </span> */}
                                </>
                            )}

                        {confirmedHero && !openCelebrationModal && (
                            <div
                                style={{
                                    width: "90%",
                                    height: "100%",
                                    textAlign: "center",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "start",
                                }}
                            >
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{
                                        width: "100%",
                                        marginBottom: "0px",
                                    }}
                                >
                                    {/* <Grid item xs={3}></Grid> */}
                                    <Grid
                                        item
                                        xs={12}
                                        style={{
                                            fontFamily: "PPNeueMachina",
                                            fontSize: matchesMobile
                                                ? "14px"
                                                : matchesSmall
                                                ? "16px"
                                                : "18px",
                                            textAlign: "center",
                                            color: "#ffb631",
                                        }}
                                    >
                                        STEP 2: REVIEW AND CONFIRM
                                    </Grid>
                                </Grid>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{
                                        width: "100%",
                                        marginTop: "15px",
                                        marginBottom: "15px",
                                    }}
                                >
                                    <Grid
                                        item
                                        xs={12}
                                        style={{
                                            fontFamily: "PPNeueMachina",
                                            fontSize: matchesMobile
                                                ? "14px"
                                                : matchesSmall
                                                ? "16px"
                                                : "20px",
                                            textAlign: "center",
                                            // cursor: "pointer",
                                            color: "#ffb631",
                                        }}
                                    >
                                        USING EXP FROM HERO #{selectedHero.id}
                                        {/* {editionsToMint > 0 ? `+ ${editionsToMint} EDITION` : "+ 0 EDITIONS"}{editionsToMint > 1 ? "S" : ""} */}
                                    </Grid>
                                </Grid>

                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{
                                        width: "100%",
                                        marginBottom: "10px",
                                    }}
                                >
                                    {editionsRemaining > 0 && (
                                        <Grid
                                            item
                                            xs={12}
                                            style={{
                                                fontFamily: "PPNeueMachina",
                                                fontSize: matchesMobile
                                                    ? "12px"
                                                    : "14px",
                                                textAlign: "center",
                                                // cursor: "pointer",
                                                color: "white",
                                            }}
                                        >
                                            FINALIZE MINT AND RECEIVE AN EDITION
                                            FOR 100'000 EXP
                                        </Grid>
                                    )}
                                    {editionsRemaining == 0 && (
                                        <Grid
                                            item
                                            xs={12}
                                            style={{
                                                fontFamily: "PPNeueMachina",
                                                fontSize: matchesMobile
                                                    ? "16px"
                                                    : "18px",
                                                textAlign: "center",
                                                // cursor: "pointer",
                                                color: "white",
                                            }}
                                        >
                                            SOLD OUT - NO MORE EDITIONS
                                        </Grid>
                                    )}
                                </Grid>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                    style={{
                                        width: "100%",
                                        marginBottom: "5px",
                                    }}
                                >
                                    {isSacrificeActive && (
                                        <Grid item>
                                            <Button
                                                onClick={handleMintWithExp}
                                                style={{
                                                    background:
                                                        isSacrificeActive
                                                            ? "#ffb631"
                                                            : "rgba(255, 182, 49,0.5)",
                                                    color: "black",
                                                    width: "250px",
                                                    padding: "10px 0",
                                                    marginTop: "10px",
                                                    // margin: "10px 0",
                                                    borderRadius: 0,
                                                    fontSize: "16px",
                                                    fontFamily: "EurostilDemi",
                                                }}
                                                disabled={!isSacrificeActive}
                                            >
                                                {isSacrificeLoading ? (
                                                    <CircularProgress
                                                        size={28}
                                                    />
                                                ) : (
                                                    "MINT WITH EXP"
                                                )}
                                            </Button>
                                        </Grid>
                                    )}
                                    {/* <Grid
                                        item
                                        xs={12}
                                        style={{
                                            fontFamily: "PPNeueMachina",
                                            fontSize: "14px",
                                            textAlign: "center",
                                            // cursor: "pointer",
                                            color: "#ff4136",
                                            paddingTop: "20px",
                                            paddingBottom: "0px",
                                        }}
                                    >
                                        WARNING: NFTS SACRIFICED ARE LOST
                                        FOREVER!
                                    </Grid> */}
                                </Grid>
                            </div>
                        )}

                        {openCelebrationModal && (
                            <div
                                style={{
                                    width: "90%",
                                    height: "100%",
                                    textAlign: "center",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{
                                        width: "100%",
                                        marginBottom: "0px",
                                    }}
                                >
                                    {/* <Grid item xs={3}></Grid> */}
                                    <Grid
                                        item
                                        xs={12}
                                        style={{
                                            fontFamily: "PPNeueMachina",
                                            fontSize: "22px",
                                            textAlign: "center",
                                            color: "#ffffff",
                                            marginBottom: "20px",
                                        }}
                                    >
                                        CONGRATULATIONS, THE MINT WAS SUCCESSFUL{" "}
                                        <br />
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        style={{
                                            fontFamily: "PPNeueMachina",
                                            fontSize: "22px",
                                            textAlign: "center",
                                            color: "#ffffff",
                                            marginBottom: "20px",
                                        }}
                                    >
                                        {/* {editionsToMint > 0 ? `+ ${editionsToMint} EDITION` : ""}{editionsToMint > 1 ? "S" : ""} */}
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        style={{
                                            fontFamily: "EurostilNormal",
                                            fontSize: "15px",
                                            textAlign: "center",
                                            // italic
                                            fontStyle: "italic",
                                            color: "#ffffff",
                                            marginBottom: "20px",
                                        }}
                                    >
                                        {/* Talanji feasts on your Spirits, the echo of the ancestors resonates, <br/> soon illuminating the one who will inherit the ancient power. */}
                                    </Grid>
                                </Grid>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{
                                        width: "100%",
                                        // marginBottom: "10px",
                                    }}
                                ></Grid>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                    style={{
                                        width: "100%",
                                        marginBottom: "5px",
                                    }}
                                >
                                    <Grid item>
                                        <Button
                                            onClick={handleCloseSacrifice}
                                            style={{
                                                background: "#ffb631",
                                                color: "black",
                                                width: "280px",
                                                padding: "10px 0",
                                                marginTop: "15px",
                                                // margin: "10px 0",
                                                borderRadius: 0,
                                                fontSize: "20px",
                                                fontFamily: "EurostilDemi",
                                            }}
                                        >
                                            {"CLOSE"}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </div>
                        )}
                    </div>
                </Fade>
            </Modal>
            <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                style={{
                    width: "100%",
                    paddingBottom: "90px",
                }}
            >
                <>
                    <span
                        style={{
                            fontSize: matchesMobile
                                ? "20px"
                                : matchesMedium
                                ? "25px"
                                : matchesSmall
                                ? "20px"
                                : "32px",
                            fontFamily: "PPNeueMachina",
                            marginBottom: "5px",
                            fontWeight: "900",
                            color: "#ffb631",
                        }}
                    >
                        Kaluthiel – The Keeper
                    </span>
                    <p
                        style={{
                            fontSize: matchesSmall ? "12px" : "14px",
                            // margin: "12px 0",
                            letterSpacing: 2,
                            fontWeight: 100,
                            width: matchesMobile ? "80%" : "50%",
                            fontFamily: "EurostilNormal",
                            whiteSpace: "pre-line",
                            textAlign: "center",
                            fontStyle: "italic",
                        }}
                    >
                        ..keeper of forsaken spirits, sealed in timeless prisons
                        in the silent forgotten dark beyond the stars.. <br />{" "}
                        <br />
                    </p>
                    {pageOpen && (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexDirection: "column",
                                width: "90%",
                                paddingTop: "25px",
                            }}
                        >
                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                alignItems="start"
                                style={{ width: "100%" }}
                            >
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={8}
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: "100%",
                                        maxWidth: "700px",
                                        // marginTop: "20px",
                                    }}
                                >
                                    <div className="videoContainer">
                                        <img
                                            style={{
                                                width: "100%",
                                                marginTop: "0%",
                                            }}
                                            onClick={handleImageClick}
                                            src={editionImage}
                                        />
                                        {videoSrc && (
                                            <video
                                                controls
                                                autoPlay
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "contain",
                                                }}
                                            >
                                                <source
                                                    src={videoSrc}
                                                    type="video/mp4"
                                                />
                                            </video>
                                        )}
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            width: "100%",
                                            color: "grey",
                                            fontSize: "12px",
                                            fontWeight: 100,
                                            fontFamily: "EurostilNormal",
                                            fontStyle: "italic",
                                            paddingTop: "5px",
                                            paddingBottom: "0px",
                                        }}
                                    >
                                        {/* {"Click to play video"} */}
                                    </div>
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={4}
                                    style={{ marginTop: "0px" }}
                                >
                                    <div
                                        style={{
                                            marginTop: "50px",
                                            fontSize: matchesMobile
                                                ? "20px"
                                                : "24px",
                                            fontFamily: "EurostilDemi",
                                            color: "#ffb631",
                                            textAlign: "center",
                                            fontStyle: "italic",
                                        }}
                                    >
                                        <span> Limited Edition </span>
                                    </div>

                                    <div
                                        style={{
                                            marginTop: "20px",
                                            fontSize: matchesMobile
                                                ? "16px"
                                                : "16px",
                                            fontFamily: "EurostilDemi",
                                            color: "#ffffff",
                                            textAlign: "center",
                                            fontStyle: "bold",
                                        }}
                                    >
                                        3 Spirits Sacrificed = 1 Edition of
                                        Zenith <br />
                                        <br />
                                        First come first served <br />
                                        {/* <br />
                                        20 extra editions are available{" "}
                                        <Link
                                            style={{ color: "#ffb631" }}
                                            target="_blank"
                                            to="/zenith-mint"
                                        >
                                            here
                                        </Link>{" "}
                                        via 0.1 ETH Sale <br /> */}
                                        {/* will receive an edition of "The Conclave". <br/> */}
                                        {/* span in eurostilnormal */}
                                        <br />
                                        {/* <span style={{fontFamily: "EurostilNormal", fontSize: "14px"}}>
                                          There are 31 winning spots, but 32 editions..
                                        </span> */}
                                    </div>
                                    <Grid
                                        item
                                        xs={12}
                                        style={{
                                            marginTop: "15px",
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <Button
                                            style={{
                                                background:
                                                    address &&
                                                    isConnected &&
                                                    isChainSupported &&
                                                    isSacrificeActive &&
                                                    editionsRemaining > 0
                                                        ? "#ffb631"
                                                        : "gray",
                                                color: "black",
                                                width: matchesMobile
                                                    ? "80%"
                                                    : "300px",
                                                padding: "20px 0",
                                                marginTop: "0px",
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                borderRadius: 0,
                                                fontSize: matchesSmall
                                                    ? "16px"
                                                    : matchesMobile
                                                    ? "18px"
                                                    : "18px",
                                                fontFamily: "EurostilDemi",
                                            }}
                                            disabled={
                                                address &&
                                                isConnected &&
                                                isChainSupported &&
                                                isSacrificeActive &&
                                                editionsRemaining > 0
                                                    ? false
                                                    : true
                                            }
                                            onClick={() => {
                                                setSacrificeOpen(true);
                                            }}
                                        >
                                            <span>
                                                Mint Burn 3 Spirits{" "}
                                                {address &&
                                                isConnected &&
                                                isChainSupported
                                                    ? ""
                                                    : ""}{" "}
                                            </span>
                                        </Button>{" "}
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        style={{
                                            marginTop: "25px",
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <Button
                                            style={{
                                                background:
                                                    address &&
                                                    isConnected &&
                                                    isChainSupported &&
                                                    isSacrificeActive &&
                                                    editionsRemaining > 0
                                                        ? "#ffb631"
                                                        : "gray",
                                                color: "black",
                                                width: matchesMobile
                                                    ? "80%"
                                                    : "300px",
                                                padding: "20px 0",
                                                marginTop: "0px",
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                borderRadius: 0,
                                                fontSize: matchesSmall
                                                    ? "16px"
                                                    : matchesMobile
                                                    ? "18px"
                                                    : "18px",
                                                fontFamily: "EurostilDemi",
                                            }}
                                            disabled={
                                                address &&
                                                isConnected &&
                                                isChainSupported &&
                                                isSacrificeActive &&
                                                editionsRemaining > 0
                                                    ? false
                                                    : true
                                            }
                                            onClick={() => {
                                                handleMintEdition();
                                            }}
                                        >
                                            {isSacrificeLoading ? (
                                                <CircularProgress size={28} />
                                            ) : (
                                                <span>
                                                    MINT FOR 0.3 ETH
                                                    {address &&
                                                    isConnected &&
                                                    isChainSupported
                                                        ? ""
                                                        : ""}{" "}
                                                </span>
                                            )}
                                        </Button>{" "}
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        style={{
                                            marginTop: "25px",
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <Button
                                            style={{
                                                background:
                                                    address &&
                                                    isConnected &&
                                                    isChainSupported &&
                                                    isSacrificeActive &&
                                                    editionsRemaining > 0
                                                        ? "#ffb631"
                                                        : "gray",
                                                color: "black",
                                                width: matchesMobile
                                                    ? "80%"
                                                    : "300px",
                                                padding: "20px 0",
                                                marginTop: "0px",
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                borderRadius: 0,
                                                fontSize: matchesSmall
                                                    ? "16px"
                                                    : matchesMobile
                                                    ? "18px"
                                                    : "18px",
                                                fontFamily: "EurostilDemi",
                                            }}
                                            disabled={
                                                address &&
                                                isConnected &&
                                                isChainSupported &&
                                                isSacrificeActive &&
                                                editionsRemaining > 0
                                                    ? false
                                                    : true
                                            }
                                            onClick={() => {
                                                setExpModalOpen(true);
                                            }}
                                        >
                                            {/* {isSacrificeLoading ? (
                                                <CircularProgress size={28} />
                                            ) : ( */}
                                            <span>
                                                MINT FOR 100'000 EXP
                                                {address &&
                                                isConnected &&
                                                isChainSupported
                                                    ? ""
                                                    : ""}{" "}
                                            </span>
                                            {/* )} */}
                                        </Button>{" "}
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        style={{ marginTop: "10px" }}
                                    >
                                        {/* <div
                                        style={{
                                           marginTop: "20px",
                                            fontSize: matchesMobile ? "16px" : "30px",
                                            fontFamily: "EurostilDemi",
                                            color: "#ffffff",
                                            textAlign: "center",
                                          }}
                                      >
                                      
                                        TOTAL SPIRITS SACRIFICED:  <span style={{color: "#ffb631"}}> {sacrificeCounter} </span>
                                      </div> */}
                                        <div
                                            style={{
                                                marginTop: "40px",
                                                fontSize: matchesMedium
                                                    ? "16px"
                                                    : matchesMobile
                                                    ? "16px"
                                                    : "20px",
                                                fontFamily: "EurostilDemi",
                                                color: "#ffffff",
                                                textAlign: "center",
                                            }}
                                        >
                                            EDITIONS REMAINING:{" "}
                                            <span style={{ color: "#ffb631" }}>
                                                {" "}
                                                {editionsRemaining} / 20{" "}
                                            </span>
                                        </div>
                                    </Grid>
                                    {isConnected &&
                                        isSacrificeActive &&
                                        editionsRemaining == 0 && (
                                            <Grid
                                                item
                                                xs={12}
                                                style={{
                                                    fontFamily: "EurostilDemi",
                                                    fontSize: matchesMobile
                                                        ? "16px"
                                                        : "20px",
                                                    textAlign: "center",
                                                    // cursor: "pointer",
                                                    color: "rgb(255, 65, 54)",
                                                    marginTop: "20px",
                                                }}
                                            >
                                                SOLD OUT - NO MORE EDITIONS VIA
                                                BURN
                                            </Grid>
                                        )}
                                </Grid>
                            </Grid>
                            {/* <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                                style={{
                                    width: "100%",
                                    marginBottom: "100px",
                                }}
                            >
                                <Grid
                                    item
                                    xs={12}
                                    style={{
                                        marginTop: "25px",
                                        display: "flex",
                                        justifyContent: "center",
                                    }}
                                >
                                    <Button
                                        style={{
                                            background:
                                                address &&
                                                isConnected &&
                                                isChainSupported &&
                                                isSacrificeActive &&
                                                editionsRemaining > 0
                                                    ? "#ffb631"
                                                    : "gray",
                                            color: "black",
                                            width: matchesMobile
                                                ? "80%"
                                                : "50%",
                                            padding: "25px 0",
                                            marginTop: "0px",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            borderRadius: 0,
                                            fontSize: "16px",
                                            fontFamily: "EurostilDemi",
                                        }}
                                        disabled={
                                            address &&
                                            isConnected &&
                                            isChainSupported &&
                                            isSacrificeActive &&
                                            editionsRemaining > 0
                                                ? false
                                                : true
                                        }
                                        onClick={() => {
                                            setSacrificeOpen(true);
                                        }}
                                    >
                                        <span>
                                            Mint - Burn 3 Spirits{" "}
                                            {address &&
                                            isConnected &&
                                            isChainSupported
                                                ? ""
                                                : ""}{" "}
                                        </span>
                                    </Button>{" "}
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    style={{
                                        marginTop: "25px",
                                        display: "flex",
                                        justifyContent: "center",
                                    }}
                                >
                                    <Button
                                        style={{
                                            background:
                                                address &&
                                                isConnected &&
                                                isChainSupported &&
                                                isSacrificeActive &&
                                                editionsRemaining > 0
                                                    ? "#ffb631"
                                                    : "gray",
                                            color: "black",
                                            width: matchesMobile
                                                ? "80%"
                                                : "50%",
                                            padding: "25px 0",
                                            marginTop: "0px",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            borderRadius: 0,
                                            fontSize: "16px",
                                            fontFamily: "EurostilDemi",
                                        }}
                                        disabled={
                                            address &&
                                            isConnected &&
                                            isChainSupported &&
                                            isSacrificeActive &&
                                            editionsRemaining > 0
                                                ? false
                                                : true
                                        }
                                        onClick={() => {
                                            handleMintEdition();
                                        }}
                                    >
                                        {isSacrificeLoading ? (
                                            <CircularProgress size={28} />
                                        ) : (
                                            <span>
                                                MINT FOR 0.3 ETH
                                                {address &&
                                                isConnected &&
                                                isChainSupported
                                                    ? ""
                                                    : "(Connect Wallet)"}{" "}
                                            </span>
                                        )}
                                    </Button>{" "}
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    style={{
                                        marginTop: "25px",
                                        display: "flex",
                                        justifyContent: "center",
                                    }}
                                >
                                    <Button
                                        style={{
                                            background:
                                                address &&
                                                isConnected &&
                                                isChainSupported &&
                                                isSacrificeActive &&
                                                editionsRemaining > 0
                                                    ? "#ffb631"
                                                    : "gray",
                                            color: "black",
                                            width: matchesMobile
                                                ? "80%"
                                                : "50%",
                                            padding: "25px 0",
                                            marginTop: "0px",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            borderRadius: 0,
                                            fontSize: "16px",
                                            fontFamily: "EurostilDemi",
                                        }}
                                        disabled={
                                            address &&
                                            isConnected &&
                                            isChainSupported &&
                                            isSacrificeActive &&
                                            editionsRemaining > 0
                                                ? false
                                                : true
                                        }
                                        onClick={() => {
                                            setExpModalOpen(true);
                                        }}
                                    >
                                        {isSacrificeLoading ? (
                                            <CircularProgress size={28} />
                                        ) : (
                                            <span>
                                                MINT FOR 100'000 EXP
                                                {address &&
                                                isConnected &&
                                                isChainSupported
                                                    ? ""
                                                    : "(Connect Wallet)"}{" "}
                                            </span>
                                        )}
                                    </Button>{" "}
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    style={{ marginTop: "10px" }}
                                >
                                    <div
                                        style={{
                                            marginTop: "20px",
                                            fontSize: matchesMobile
                                                ? "16px"
                                                : "30px",
                                            fontFamily: "EurostilDemi",
                                            color: "#ffffff",
                                            textAlign: "center",
                                        }}
                                    >
                                        EDITIONS REMAINING:{" "}
                                        <span style={{ color: "#ffb631" }}>
                                            {" "}
                                            {editionsRemaining} / 20{" "}
                                        </span>
                                    </div>
                                </Grid>
                                {isConnected &&
                                    isSacrificeActive &&
                                    editionsRemaining == 0 && (
                                        <Grid
                                            item
                                            xs={12}
                                            style={{
                                                fontFamily: "EurostilDemi",
                                                fontSize: matchesMobile
                                                    ? "16px"
                                                    : "20px",
                                                textAlign: "center",
                                                // cursor: "pointer",
                                                color: "rgb(255, 65, 54)",
                                                marginTop: "20px",
                                            }}
                                        >
                                            SOLD OUT - NO MORE EDITIONS VIA BURN
                                        </Grid>
                                    )}
                            </Grid> */}
                        </div>
                    )}
                </>
            </Grid>
        </Grid>
    );
};

export default EditionBurnMintExp;
